import { axiosPost } from './apiClient';

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/report/analytics`;

const post = async (path, payload) => {
  const response = await axiosPost(`${BASE_URL}/${path}`, payload);
  if (response?.status !== 'SUCCESS') throw new Error(response?.message || 'Unable to load report');
  return response.data;
};

export default {
  getCustomerEngagementReport: (payload) => post('customer-engagement', payload),
  getCustomerCart: (customer_id) => post('customer-cart', { customer_id }),
  getSalesReport: (payload) => post('sales', payload),
  getExpressDelayReport: (payload) => post('express-delay', payload),
  getOrderProcessingReport: (payload) => post('order-processing', payload),
  getAbandonedCartsReport: (payload) => post('abandoned-carts', payload),
  getPickingExceptionsReport: (payload) => post('picking-exceptions', payload),
};
